import Link from 'next/link';
import styled from 'styled-components';
import i18n from 'src/utils/translate';
import { useWindowSize } from 'src/utils/hooks/useWindowSize';
import { screenSmMin } from 'styles-js/mediaQueries';
import { DefaultLayout } from 'src/components/layouts';
import GlobalSearch from 'src/modules/search/shared/components/searchBar';
import { Community } from 'src/constants/types';
import CommunityListItem from 'src/modules/nhs/communityListItem';
import { titleLarge, text, titleSmall } from 'styles-js/mixins/typography';
import Icon from 'src/components/icon';
export default function NhsPage({
  communities
}: {
  communities: Community[];
}) {
  const screenWidth = useWindowSize().width;
  const isMobile = screenWidth < screenSmMin;
  return <DefaultLayout data-sentry-element="DefaultLayout" data-sentry-component="NhsPage" data-sentry-source-file="nhsPage.tsx">
      <ContentWrapper data-sentry-element="ContentWrapper" data-sentry-source-file="nhsPage.tsx">
        <Section data-sentry-element="Section" data-sentry-source-file="nhsPage.tsx">
          <NhsWrapper data-sentry-element="NhsWrapper" data-sentry-source-file="nhsPage.tsx">
            <NhsInfo data-sentry-element="NhsInfo" data-sentry-source-file="nhsPage.tsx">
              <Title data-sentry-element="Title" data-sentry-source-file="nhsPage.tsx">{i18n.t(`The world's largest social network for health`)}</Title>
              <span>
                {i18n.t('Ask questions and share answers, advice, and support in hundreds of condition and wellbeing communities led by trusted organisations.')}
              </span>
            </NhsInfo>
            <NhsLogoWrapper data-sentry-element="NhsLogoWrapper" data-sentry-source-file="nhsPage.tsx">
              <div>{i18n.t('In cooperation with')}</div>
              <img alt="nhs-choices-logo" src="https://assets.hu-production.be/static/nhs/blue-logo.jpg" />
            </NhsLogoWrapper>
          </NhsWrapper>
        </Section>

        <BodyWrapper data-sentry-element="BodyWrapper" data-sentry-source-file="nhsPage.tsx">
          <LeftPanel data-sentry-element="LeftPanel" data-sentry-source-file="nhsPage.tsx">
            <Section data-sentry-element="Section" data-sentry-source-file="nhsPage.tsx">
              <Title data-sentry-element="Title" data-sentry-source-file="nhsPage.tsx">{i18n.t('Search for a community')}</Title>
              <GlobalSearch placeholder={i18n.t('Enter a condition or a topic')} searchType="communities" data-sentry-element="GlobalSearch" data-sentry-source-file="nhsPage.tsx" />
            </Section>

            <Section data-sentry-element="Section" data-sentry-source-file="nhsPage.tsx">
              <Title data-sentry-element="Title" data-sentry-source-file="nhsPage.tsx">{i18n.t('Popular communities')}</Title>
              <div>
                <div>
                  {!communities.length ? <>{i18n.t('No communites discovered.')}</> : communities.map(community => <CommunityListItem community={community} isMobile={isMobile} key={community.communityId} />)}
                </div>
              </div>
            </Section>
          </LeftPanel>

          <RightPanel data-sentry-element="RightPanel" data-sentry-source-file="nhsPage.tsx">
            <img alt="healthunlocked-graphic" src="https://images.hu-production.be/static/img/home/home-1-mobile.png" />
            <Title data-sentry-element="Title" data-sentry-source-file="nhsPage.tsx">{i18n.t('About HealthUnlocked')}</Title>
            <p>{i18n.t(`We are the world's largest social network for health, with 1.2 million members across the globe, and growing.`)}</p>
            <p>
              {i18n.t('We connect people with the same health conditions, where they can share experiences and get answers to questions' + 'about their chronic conditions and wellbeing needs - empowering people with knowledge for enhanced self-care.')}
            </p>
            <Link passHref as="/" href="/" data-sentry-element="Link" data-sentry-source-file="nhsPage.tsx">
              {'Learn more'}<Icon icon="open-right" data-sentry-element="Icon" data-sentry-source-file="nhsPage.tsx" />
            </Link>
          </RightPanel>
        </BodyWrapper>
      </ContentWrapper>
    </DefaultLayout>;
}
const ContentWrapper = styled.div`
  padding: 20px 15px 50px;
`;
const BodyWrapper = styled.div`
  display: flex;
  @media (${props => props.theme.underScreenSmall}) {
    flex-direction: column;
  }
`;
const LeftPanel = styled.div`
  flex-basis: 66.66%;
  @media (${props => props.theme.overScreenSmall}) {
    padding-right: 150px;
  }
`;
const Section = styled.div`
  padding: 10px 0 20px;
`;
const RightPanel = styled(Section)`
  flex-basis: 33.33%;
  > p {
    padding-bottom: 15px;
  }
  > img {
    width: 100%;
    height: auto;
    margin-bottom: 30px;
  }
`;
const Title = styled.div`
  ${titleLarge};
  padding-bottom: 25px;
`;
const NhsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 20px;
  border:  ${({
  theme
}) => theme.greyLine};
  @media (${props => props.theme.underScreenSmall}) {
    flex-direction: column;
  }
`;
const NhsInfo = styled.div`
  ${text};
  flex-basis: 66.66%;
  padding-bottom: 10px;
  @media (${props => props.theme.underScreenSmall}) {
    padding-bottom: 20px;
  }
`;
const NhsLogoWrapper = styled.div`
  flex-basis: 33.33%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;

  > div {
    ${titleSmall};
    padding-bottom: 10px;
  }

  > img {
    width: 100px;
    height: auto;
  }
`;